import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import _ from "lodash"
import $ from "jquery"
import { Container, Row, Col } from "react-bootstrap"
import ModalTiny from "react-bootstrap/Modal"
import parse from "html-react-parser"
import Select from "react-dropdown-select"
import AdvertsOne from "./Adverts/AdvertsOne"
import PropertyCard from "../PropertyCard/PropertyCard"
import NoImage from "../../../images/property-no-image.png"
import { useWindowSize } from "../../../hooks/winodw-size"
import SeoStructuredData from "../../Seo/StructuredData"
import { ShowProcessedImage } from "../../common/ggfx-client/module/components/show-image"
import imageConfig from "../../../../static/images/config.json"
import Enquiry from "./BookViewing"
import YieldEnquiry from "../YieldInfo"
import "./SearchList.scss"

// Property Type
const SortByBox = ({
  sortBy,
  sortByIndex,
  items,
  promotion,
  changeStateAndUrl,
}) => {
  let currentSortBy = sortBy || sortByIndex || ""

  const [placeholder, setPlaceholder] = useState("Highest Price First")

  useEffect(() => {
    if (typeof window !== "undefined") {
      const localSort = localStorage.getItem("sortby-value")
      if (localSort?.includes("_most_recent")) {
        setPlaceholder("Recently Added")
      } else if (localSort?.includes("_distance_asc")) {
        setPlaceholder("Nearest First")
      } else if (localSort?.includes("_price_asc")) {
        setPlaceholder("Lowest Price First")
      } else if (promotion.includes("buy to let opportunity")) {
        setPlaceholder("Highest Yield")
      }
    }
  }, [])

  const handleChange = selected => {
    const newSortBy = selected[0].value
    localStorage.setItem("sortby-value", newSortBy)
    changeStateAndUrl({
      sortBy: newSortBy,
      page: 0,
    })
  }

  return (
    <div className="filter-option result-search-recent-filter">
      <i className="icon-sort"></i>
      <Select
        options={items}
        placeholder={placeholder}
        classNamePrefix={"select-opt filter-box"}
        className="filter-sortby"
        value={items.find(obj => obj.value === currentSortBy) || items[0]}
        searchable={false}
        onChange={handleChange}
      />
    </div>
  )
}

const CustomPagination = ({
  nbPages,
  page,
  currentState = {},
  changeStateAndUrl,
}) => {
  const currentPage = Number(page) || 1 // Ensures it's always a number
  useEffect(() => {
    $(".page-next").attr("disabled", currentPage >= nbPages)
    $(".page-back").attr("disabled", currentPage <= 1)
  }, [currentPage, nbPages])

  const updatePage = pageNumber => {
    changeStateAndUrl({ ...currentState, page: Number(pageNumber) })

    if (typeof window !== "undefined") {
      window.scroll({
        top: -100,
        behavior: "smooth",
      })
    }
  }

  return (
    <Row>
      <Col md={3} className="d-none d-md-block">
        <button
          className="page-back"
          onClick={() => updatePage(currentPage - 1)}
        >
          <i className="page-arrow-back"></i> Back
        </button>
      </Col>
      <Col md={6} className="text-center">
        Page:
        <select
          id="pagination-select"
          value={currentPage}
          onChange={e => updatePage(parseInt(e.target.value))}
        >
          {Array.from({ length: nbPages }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>
        of {nbPages}
      </Col>
      <Col md={3} className="d-none d-md-block">
        <button
          className="page-next"
          onClick={() => updatePage(currentPage + 1)}
        >
          Next <i className="page-arrow-next"></i>
        </button>
      </Col>
    </Row>
  )
}

const CustomPaginationRender = CustomPagination

const SearchList = props => {
  const [windowWidth] = useWindowSize()
  const [info, setInfo] = useState(false)
  const [wishlistproperties, setWishlistProperties] = useState([])
  const [loginstatus, setLoginStatus] = useState("")
  const [savetype, setSaveType] = useState(false)
  const [addresponse, setAddResponse] = useState("")
  const [wish, setWish] = useState("")
  const [openPopup, setOpenPopup] = React.useState(false)
  const [crmId, setCrmId] = React.useState("")

  const getwishlistproperty = url => {
    fetch(url, {
      method: "GET",
      redirect: "follow",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then(response => response.text())
      .then(result => {
        setWishlistProperties(result)
      })
      .catch(error => console.log("error", error))
  }

  useEffect(() => {
    localStorage.removeItem("initialViewProperty")
    var myAccountLogin = localStorage.getItem("myaccount-login-status")
    setLoginStatus(myAccountLogin)
    let cookieProperty = localStorage.getItem("cookieProperty")
    if (myAccountLogin && myAccountLogin == "true") {
      getwishlistproperty(
        `https://myaccount.wardsofkent.co.uk/api/propertyshortlist/`
      )
    }
    if (cookieProperty) {
      cookieProperty = JSON.parse(cookieProperty)
      setWishlistProperties(cookieProperty.map(item => item.crm_id))
      console.log(
        "CookieProperty",
        cookieProperty.map(item => item.crm_id)
      )
    }
  }, [])

  // fixing build time error - WebpackError: ReferenceError: localStorage is not defined
  let login = null

  if (typeof window !== "undefined" && window.localStorage) {
    login = localStorage.getItem("myaccount-login-status")
  }

  const data = useStaticQuery(graphql`
    query {
      glstrapi {
        searchResultsAdverts(sort: "Sort:ASC") {
          Sort
          Title
          Content
          CTA_2_Label
          CTA_1_Label
          CTA_2_Link {
            id
          }
          CTA_1_Link {
            id
          }
          Background_Image {
            url
            alternativeText
          }
        }
      }
    }
  `)

  const adverts = data.glstrapi.searchResultsAdverts
  const cloud_url = process.env.GATSBY_CLOUD_URL
  const handleSecond = id => {
    var className = $(`#${id}-div`).attr("class")
    if (className == "icon-heart") {
      $(`#${id}-div`).removeClass("icon-heart").addClass("icon-heart-fill")
      $(`#${id}-wish-icon`).text("Saved")
      wishlistpropertyadd(
        `https://myaccount.wardsofkent.co.uk/api/propertyshortlist/${id}`,
        "add"
      )
      setSaveType(true)
    }
    if (className == "icon-heart-fill") {
      $(`#${id}-div`).removeClass("icon-heart-fill").addClass("icon-heart")
      $(`#${id}-wish-icon`).text("Save")
      wishlistpropertyadd(
        `https://myaccount.wardsofkent.co.uk/api/propertyshortlist/${id}`,
        "remove"
      )
      setSaveType(false)
    }
  }

  const saveCookieProperty = property => {
    console.log("property", property)
    let cookieProperty = localStorage.getItem("cookieProperty")
    if (cookieProperty && property.search_type == "sales") {
      cookieProperty = JSON.parse(cookieProperty)
      let isExist = cookieProperty.find(item => item.crm_id == property.crm_id)
      if (isExist) {
        cookieProperty = cookieProperty.filter(
          item => item.crm_id != property.crm_id
        )
        localStorage.setItem(
          "cookieProperty",
          JSON.stringify([...cookieProperty])
        )
        setWishlistProperties(cookieProperty.map(item => item.crm_id))
      }

      if (cookieProperty.length < 3 && !isExist) {
        localStorage.setItem(
          "cookieProperty",
          JSON.stringify([...cookieProperty, property])
        )
        setWishlistProperties([...wishlistproperties, property.crm_id])
      } else if (cookieProperty.length >= 3) {
        setOpenPopup(true)
        setCrmId(property.crm_id)
      }
    } else if (property.search_type == "sales") {
      localStorage.setItem("cookieProperty", JSON.stringify([property]))
      setWishlistProperties([property.crm_id])
    } else {
      setOpenPopup(true)
      setCrmId(property.crm_id)
    }
  }

  const wishlistpropertyadd = async (url, type) => {
    var raw = JSON.stringify("remove")
    try {
      fetch(url, {
        method: "PUT",
        redirect: "follow",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
          "Content-Type": "application/json",
        },
        body: type == "remove" ? raw : "",
        credentials: "include",
      })
        .then(response => response.text())
        .then(result => {
          setAddResponse(result)
        })
        .catch(error => console.log("error", error))
    } catch (error) {
      console.error(error)
    }
  }

  if (typeof window !== "undefined" && typeof document !== "undefined") {
    $(document).on("click", ".ais-Pagination-link", function () {
      if (window) {
        window.scroll({
          top: -100,
          behavior: "smooth",
        })
      }
    })
  }

  const pageurl = typeof window !== "undefined" ? window.location.href : ""
  var blockCount = 0

  var sortItem = [
    { value: props.index_name, label: "Highest Price First" },
    { value: props.index_name + "_distance_asc", label: "Nearest First" },
    { value: props.index_name + "_price_asc", label: "Lowest Price First" },
  ]

  //If the promtion type is Buy to let it append yield sorting
  if (props.promotion.includes("with buy to let opportunity")) {
    sortItem.push(
      { value: props.index_name + "_yield_desc", label: "Higest Yield" },
      { value: props.index_name + "_yield_asc", label: "Lowest Yield" }
    )
  }

  //Finally append the reacently added sort item
  sortItem.push({
    value: props.index_name + "_most_recent",
    label: "Recently Added",
  })

  //This code snippet for setting up description length based on window size
  var descLength = 160
  if (windowWidth >= 1600 && windowWidth <= 1700) {
    descLength = 200
  } else if (windowWidth >= 1701 && windowWidth <= 1800) {
    descLength = 250
  } else if (windowWidth >= 1801 && windowWidth <= 1900) {
    descLength = 300
  } else if (windowWidth >= 1901 && windowWidth <= 2000) {
    descLength = 350
  } else if (windowWidth >= 2001) {
    descLength = 500
  }

  var res_page = parseInt(props.page)
  var res_page_one = res_page * 20
  var res_page_two = res_page_one - 19
  if (parseInt(props?.nbHits) < res_page_one) {
    res_page_one = props?.nbHits
  }

  useEffect(() => {
    if (parseInt(props?.nbHits) < 5) {
      var target = $(".search-list-block")
      $("html,body").animate({ scrollTop: target.offset().top - 100 }, 10)
    }
  }, [props?.nbHits])

  let myH1 = props.h1
  if (props?.mapdragbyuser) {
    const myH1Arr = myH1.split(" in ")
    myH1 = myH1Arr[0] + " in this area"
  }

  return (
    <React.Fragment>
      <SeoStructuredData
        type="SearchResultsPage"
        publisher={{
          name: "Wards of Kent",
          logo: cloud_url + "/images/mail-logo.png",
        }}
        total={props?.nbHits}
        entity={{
          name: `Property for sale ${props.search_area} with Wards of Kent`,
          desc: "View Property that Wards of Kent has for sale, or create an email alert for this search.",
          list: _.map(props?.hits, o =>
            _.extend(
              {
                name: `${o.bedroom} bed ${o.building ? o.building + " " : ""}${
                  o.searchBuilding
                } in ${o.address}`,
                url:
                  o.search_type === "sales"
                    ? process.env.GATSBY_SITE_URL +
                      "/property-for-sale/" +
                      o.slug +
                      "-" +
                      o.crm_id
                    : process.env.GATSBY_SITE_URL +
                      "/property-for-rent/" +
                      o.slug +
                      "-" +
                      o.crm_id,
              },
              o
            )
          ),
        }}
      />
      <Container id="res-div-one">
        {props.mapView ? (
          ""
        ) : (
          <React.Fragment>
            <Row className="property-view">
              <Col md="12">
                <h1 className="d-none">
                  {props.promotion == "with buy to let opportunity"
                    ? `${props?.nbHits.toLocaleString()} Browse our selection of buy-to-let properties currently available on the market.`
                    : `${props?.nbHits.toLocaleString()} ${myH1}`}
                </h1>
                <div className={`${props.mapView ? "grid" : ""}`}>
                  <span className="search-number">
                    {props?.nbHits.toLocaleString()}{" "}
                    {props.promotion == "with buy to let opportunity"
                      ? "Browse our selection of buy-to-let properties currently available on the market."
                      : myH1}
                    <i
                      className="icon-info"
                      onClick={() => {
                        setInfo(!info)
                      }}
                    ></i>
                  </span>
                  {info && (
                    <div className="result-desc-content">
                      {props.promotion == "with buy to let opportunity" ? (
                        <p className="col-md-12 mb-0 mt-2">
                          We show you what will offer you the highest possible
                          yields to make things even easier for you.
                        </p>
                      ) : (
                        <p className="col-md-12 mb-2 mt-2">
                          {" "}
                          {props.desc}{" "}
                          <Link to="/get-in-touch/">
                            <u>contact us</u>
                          </Link>
                          .
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                {props?.nbHits > 0 && (
                  <p className="showing-property-text">
                    Showing {res_page_two}-{res_page_one} of{" "}
                    {props?.nbHits.toLocaleString()} properties
                  </p>
                )}
              </Col>
              <Col md="6" className="filter-map-and-sort">
                <div>
                  <div className="search-right">
                    {props.mapView ? (
                      <button
                        type="button"
                        className="list-view"
                        onClick={() => {
                          props.changeToListUrl()
                          sessionStorage.setItem("MainView", "List")
                          localStorage.removeItem("map-hits")
                        }}
                      >
                        <i className="icon-view"></i>
                        <span>List View</span>
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="view-pin"
                        onClick={() => {
                          props.changeToMapUrl()
                          sessionStorage.setItem("MainView", "Grid")
                        }}
                      >
                        <i className="icon-pin"></i>
                        <span>Map View</span>
                      </button>
                    )}
                    {!props.mapView && (
                      <div className="recent-filter-block">
                        <SortByBox
                          sortBy={props.sortBy}
                          sortByIndex={props.sortByIndex}
                          items={sortItem}
                          promotion={props.promotion}
                          changeStateAndUrl={props.changeStateAndUrl}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </React.Fragment>
        )}
        <div
          className={`${
            props.mapView ? "property-card-list lg-view d-none" : "no-pad"
          }`}
        >
          <Row>
            {props?.hits.map((item, i) => {
              if ((i + 1) % 6 === 0) {
                blockCount = blockCount + 1
                if (adverts.length == blockCount) {
                  blockCount = 0
                }
              }

              var url = ""
              if (item.search_type === "sales") {
                url =
                  "/property-for-sale/" + item.slug + "-" + item.crm_id + "/"
              } else if (item.search_type === "lettings") {
                url = "/property-to-rent/" + item.slug + "-" + item.crm_id + "/"
              }
              var image_url = ""
              var image_url_no_image = ""
              var sub_image_url_one = ""
              var sub_image_url_two = ""
              var sub_image_url_three = ""

              if (item.images1) {
                image_url = item.images1.images[0]
              }
              if (item.images2) {
                sub_image_url_one = item.images2.images[0]
                sub_image_url_two = item.images2.images[1]
                sub_image_url_three = item.images2.images[2]
              }
              if (item.images3) {
                image_url_no_image = item.images3.images_src[0]
              }

              let processedImages = JSON.stringify({})
              if (item.imagetransforms?.images_Transforms) {
                processedImages = item.imagetransforms.images_Transforms
              }

              const ImageRenderSmall = ({ image_url }) => {
                return (
                  <ShowProcessedImage
                    images={image_url}
                    attr={{ className: "mb-0 img-fluid", alt: "" }}
                    transforms={
                      imageConfig.property.images.searchResults2.sizes
                    }
                  />
                )
              }

              var wish = ""
              if (_.includes(wishlistproperties, item.crm_id)) {
                wish = "true"
              }

              var tour_video = true
              var tour_video_url = ""
              if (item.virtual_tour_url && item.virtual_tour_url.length > 0) {
                tour_video_url = String(item.virtual_tour_url[0])
                let vimeo = tour_video_url.indexOf("vimeo.com") > -1
                if (vimeo == true) {
                  tour_video = true
                } else {
                  tour_video = false
                }
              }

              return (
                <React.Fragment>
                  {props.mapView ? (
                    <PropertyCard
                      image_url={image_url}
                      loginstatus={login}
                      BedCount={item.bedroom}
                      BathCount={item.bathroom}
                      areaSup={item.reception}
                      search_type={item.search_type}
                      PropertyPrice={item.price?.toLocaleString()}
                      handleSecond={handleSecond}
                      PropertyLine={item.display_address}
                      PropertyHeading={item.display_address}
                      PropertyText={item.title}
                      processedImages={processedImages}
                      crm_id={item.crm_id}
                      wish={wish}
                      url={url}
                      objectID={item.objectID}
                      showcased_property={item.showcased_property}
                      spotlight_property={item.spotlight_property}
                      virtual_tour={item.virtual_tour}
                    />
                  ) : (
                    <Col
                      lg="12"
                      md="6"
                      className="d-md-block property-card-wrapper"
                      id={item.objectID}
                    >
                      {item.showcased_property ? (
                        <div className="top-bar showcased">
                          <span className="top-bar-text">
                            Showcased Property
                          </span>
                        </div>
                      ) : item.spotlight_property ? (
                        <div className="top-bar spotlighted">
                          <span className="top-bar-text">
                            spotlighted Property
                          </span>
                        </div>
                      ) : (
                        ""
                      )}

                      <div
                        className={`property-card property-card-big ${
                          item.showcased_property
                            ? "property-card-top box-blue"
                            : item.spotlight_property
                            ? "spotlighted property-card-top box-yellow"
                            : "img-zoom"
                        } `}
                      >
                        <div className="properties-wrapper">
                          <Link
                            to={`${url}`}
                            onClick={() => {
                              // Save item.crm_id to local storage when Link is clicked
                              localStorage.setItem(
                                "initialViewProperty",
                                item.crm_id
                              )
                            }}
                            className="img-link"
                          >
                            <picture
                              className={
                                item.showcased_property
                                  ? "img-zoom"
                                  : item.spotlight_property
                                  ? "img-zoom"
                                  : ""
                              }
                            >
                              {image_url ? (
                                <ShowProcessedImage
                                  images={image_url}
                                  attr={{
                                    className: "mb-0 img-fluid",
                                    alt: `${item.display_address} - Wards of Kent`,
                                  }}
                                  transforms={
                                    imageConfig.property.images.searchResults
                                      .sizes
                                  }
                                />
                              ) : image_url_no_image ? (
                                <img src={image_url_no_image} alt="img" />
                              ) : (
                                <img src={NoImage} alt="img" />
                              )}
                            </picture>
                            {item.showcased_property ? (
                              <span className="card-line mobile-top-bar">
                                Showcased Property
                              </span>
                            ) : item.spotlight_property ? (
                              <span className="card-line mobile-top-bar">
                                spotlighted Property
                              </span>
                            ) : (
                              ""
                            )}

                            {item.showcased_property ||
                            item.spotlight_property ? (
                              <div className="gallery-img d-lg-flex d-none">
                                {sub_image_url_one ? (
                                  <ImageRenderSmall
                                    image_url={sub_image_url_one}
                                    node={item}
                                  />
                                ) : (
                                  <img src={NoImage} alt="img" />
                                )}
                                {sub_image_url_two ? (
                                  <ImageRenderSmall
                                    image_url={sub_image_url_two}
                                    node={item}
                                  />
                                ) : (
                                  <img src={NoImage} alt="img" />
                                )}
                                {sub_image_url_three ? (
                                  <ImageRenderSmall
                                    image_url={sub_image_url_three}
                                    node={item}
                                  />
                                ) : (
                                  <img src={NoImage} alt="img" />
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="btn-group-wrap">
                              <button className="btn-camera">
                                <i className="icon-camera-gallery"></i>{" "}
                                <span>
                                  1/{item.imageCount ? item.imageCount : "1"}
                                </span>
                              </button>
                              {item.virtual_tour && (
                                <button className="btn-play-circle">
                                  <i className="icon-play-circle"></i>
                                </button>
                              )}
                              {item.floorplan &&
                              JSON.stringify(item.floorplan) != "{}" ? (
                                <button className="btn-flor">
                                  <i className="icon-flor"></i>{" "}
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </Link>
                        </div>
                        <div className="about-properties">
                          <div className="properties-info ">
                            <h2>
                              <Link
                                to={`${url}`}
                                onClick={() => {
                                  // Save item.crm_id to local storage when Link is clicked
                                  localStorage.setItem(
                                    "initialViewProperty",
                                    item.crm_id
                                  )
                                }}
                              >
                                {item.display_address}
                              </Link>
                              {login == "true" ? (
                                <a
                                  href="javascript:void(0);"
                                  className="save-list d-md-none"
                                  onClick={() => {
                                    wish = ""
                                    handleSecond(item.crm_id)
                                  }}
                                >
                                  <i
                                    id={item.crm_id}
                                    className={
                                      wish ? "icon-heart-fill" : "icon-heart"
                                    }
                                  ></i>
                                </a>
                              ) : (
                                <a
                                  className="save-list d-md-none"
                                  href={`https://myaccount.wardsofkent.co.uk/Account/MainSiteLogin/?returnUrl=${pageurl}&id=${item.crm_id}`}
                                >
                                  <i
                                    id={item.crm_id}
                                    className={"icon-heart"}
                                  ></i>
                                </a>
                              )}
                            </h2>
                            {item.price_qualifier !== "POA" ? (
                              <span className="property-price">
                                £{item.price ? item.price.toLocaleString() : 0}{" "}
                                {item.search_type == "lettings" ? " PCM" : ""}
                              </span>
                            ) : (
                              <span className="property-price">
                                Price on Application
                              </span>
                            )}
                            {props.promotion ==
                              "with buy to let opportunity" && (
                              <div className="yield-in-results">
                                {item.yield ? (
                                  <p>
                                    {item.yield}% yield <YieldEnquiry />
                                  </p>
                                ) : (
                                  <p>
                                    Call us to find out this property's yield
                                  </p>
                                )}
                              </div>
                            )}
                            <div className="properties-icons">
                              {item?.bedroom > 0 && (
                                <span className="text">
                                  <i className="icon-bedroom"></i>
                                  <span className="sm-text">
                                    {item.bedroom}
                                  </span>
                                </span>
                              )}
                              {item?.bathroom > 0 && (
                                <span className="text">
                                  <i className="icon-bath"></i>
                                  <span className="sm-text">
                                    {item.bathroom}
                                  </span>
                                </span>
                              )}
                              {item?.reception > 0 && (
                                <span className="text">
                                  <i className="icon-sofa"></i>
                                  <span className="sm-text">
                                    {item.reception}
                                  </span>
                                </span>
                              )}
                              {item.virtual_tour && (
                                <span className="text video-camera d-lg-flex d-none">
                                  <i className="icon-camera-results"></i>
                                  {tour_video ? (
                                    <span className="sm-text">
                                      Video Tour Available
                                    </span>
                                  ) : (
                                    <span className="sm-text">
                                      Virtual Tour Available
                                    </span>
                                  )}
                                </span>
                              )}
                            </div>
                            {item.accommodation_summary ? (
                              <p className="d-lg-block d-none">
                                {parse(
                                  item.accommodation_summary.substr(
                                    0,
                                    descLength
                                  )
                                )}{" "}
                                {item.accommodation_summary.length > descLength
                                  ? "..."
                                  : ""}
                              </p>
                            ) : (
                              <p className="d-lg-block d-none">
                                {parse(
                                  item.long_description.substr(0, descLength)
                                )}
                                ...
                              </p>
                            )}
                            <div className="bottom-block">
                              {item.search_type == "sales" &&
                              item.sales_dept_phone ? (
                                <a
                                  href={`tel:${
                                    item.search_type == "sales"
                                      ? item.sales_dept_phone
                                      : item.search_type == "lettings"
                                      ? item.lettings_dept_phone
                                      : ""
                                  }`}
                                  className="number-text"
                                >
                                  <i className="icon-phone"></i>
                                  <span className="call-to">
                                    {item.search_type == "sales"
                                      ? item.sales_dept_phone
                                      : item.search_type == "lettings"
                                      ? item.lettings_dept_phone
                                      : ""}
                                  </span>
                                </a>
                              ) : item.search_type == "lettings" &&
                                item.lettings_dept_phone ? (
                                <a
                                  href={`tel:${
                                    item.search_type == "sales"
                                      ? item.sales_dept_phone
                                      : item.search_type == "lettings"
                                      ? item.lettings_dept_phone
                                      : ""
                                  }`}
                                  className="number-text"
                                >
                                  <i className="icon-phone"></i>
                                  <span className="call-to">
                                    {item.search_type == "sales"
                                      ? item.sales_dept_phone
                                      : item.search_type == "lettings"
                                      ? item.lettings_dept_phone
                                      : ""}
                                  </span>
                                </a>
                              ) : (
                                ""
                              )}

                              <a
                                href="javascript:void(0);"
                                className="mail-text d-md-inline-flex"
                              >
                                <i className="icon-envelope"></i>
                                <Enquiry
                                  name=""
                                  class="mail"
                                  branch={"Enquire"}
                                  property_img={image_url}
                                  crm_id={item.crm_id}
                                  page_url={pageurl}
                                  property_title={item.display_address}
                                  type={item.search_type}
                                  address={item.address}
                                >
                                  <span>Enquire</span>
                                </Enquiry>
                              </a>
                              {item.search_type == "sales" && (
                                <>
                                  {login == "true" ? (
                                    <a
                                      href="javascript:void(0);"
                                      className="save-list d-md-inline-flex d-none"
                                      onClick={() => {
                                        wish = ""
                                        handleSecond(item.crm_id)
                                      }}
                                    >
                                      <i
                                        id={`${item.crm_id}-div`}
                                        className={
                                          wish
                                            ? "icon-heart-fill"
                                            : "icon-heart"
                                        }
                                      ></i>
                                      <span id={`${item.crm_id}-wish-icon`}>
                                        {wish ? "Saved" : "Save"}
                                      </span>
                                    </a>
                                  ) : (
                                    <a
                                      className="save-list d-md-inline-flex d-none"
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        wish = ""
                                        saveCookieProperty(item)
                                      }}
                                    >
                                      <i
                                        id={item.crm_id}
                                        className={
                                          wish
                                            ? "icon-heart-fill"
                                            : "icon-heart"
                                        }
                                      ></i>
                                      <span id={`${item.crm_id}-wish-icon`}>
                                        {wish ? "Saved" : "Save"}
                                      </span>
                                    </a>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                  {(i + 1) % 6 === 0 ? (
                    <div
                      class={`property-details-help-module search-results-adverts ${blockCount}`}
                    >
                      <AdvertsOne adverts={adverts} adkey={blockCount} />
                    </div>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              )
            })}
          </Row>
        </div>
        {props.mapView && 1 == 1 ? (
          ""
        ) : (
          <div className="justify-content-center main-pagination-container no-pad">
            {props?.nbHits > 20 && (
              <>
                <React.Fragment>
                  <CustomPaginationRender
                    page={Number(props.page)}
                    nbPages={Number(props.nbPages)}
                    currentState={props}
                    changeStateAndUrl={props.changeStateAndUrl}
                  />
                </React.Fragment>
              </>
            )}
          </div>
        )}
      </Container>
      <ModalTiny
        show={openPopup}
        onHide={() => {
          setOpenPopup(false)
        }}
        className="book-a-viewing-modal modal-main-form modal myaccount-model"
      >
        <ModalTiny.Header closeButton className="contact-close-btn">
          <ModalTiny.Title className="w-100">
            <h2 className="text-center mb-0">My Account</h2>
          </ModalTiny.Title>
        </ModalTiny.Header>

        <ModalTiny.Body className="people-details-form-modal event-section">
          <p>
            Please log in to continue to save more properties, you will need to{" "}
            <a
              className="myaccountlink"
              href={`https://myaccount.wardsofkent.co.uk/Account/MainSiteLogin/?returnUrl=${pageurl}&id=${crmId}`}
            >
              log in
            </a>{" "}
            or{" "}
            <a
              className="myaccountlink"
              href={`https://myaccount.wardsofkent.co.uk/Account/MainSiteLogin/Register?returnUrl=${pageurl}&id=${crmId}`}
            >
              create an account
            </a>{" "}
          </p>
        </ModalTiny.Body>
      </ModalTiny>
    </React.Fragment>
  )
}

export default SearchList
